import { Box, styled, Typography, TypographyProps } from '@mui/material';

export const HeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
}));

export const HeaderTitle = styled(Typography)<TypographyProps>(() => ({
  fontWeight: 600,
}));

export const NewHeaderTitle = styled(Typography)<TypographyProps>(() => ({
  fontWeight: 700,
  fontSize: '24px',
  fontStyle: 'bold',
}));
